import * as i5 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Pipe, Component, Inject, InjectionToken, Input, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import * as i4 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i1 from '@angular/platform-browser';
import * as i1$2 from 'ngx-shared-services';
import { merge } from 'rxjs';
import * as i1$1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i2 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i3 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';

class SafePipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(url) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}
SafePipe.ɵfac = function SafePipe_Factory(t) { return new (t || SafePipe)(i0.ɵɵdirectiveInject(i1.DomSanitizer, 16)); };
SafePipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "safe", type: SafePipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SafePipe, [{
        type: Pipe,
        args: [{
                name: 'safe'
            }]
    }], function () { return [{ type: i1.DomSanitizer }]; }, null); })();

class SurveyComponent {
    constructor(dialogRef, data, dialog) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.dialog = dialog;
        this.url = '';
    }
    openSurvey() {
        this.dialog.open(SurveyComponent, {
            data: this.data,
        });
    }
    ngOnInit() {
        const { Survey_Response_Flex_User_Email, Survey_Response_Flex_User_Username, Survey_Response_Community_User_ID, gf_unique, } = this.data.urlParams;
        const url = new URL(this.data.iFrameUrl);
        url.searchParams.append('Survey_Response_Flex_User_Email', Survey_Response_Flex_User_Email);
        url.searchParams.append('Survey_Response_Flex_User_Username', Survey_Response_Flex_User_Username);
        url.searchParams.append('Survey_Response_Community_User_ID', Survey_Response_Community_User_ID);
        url.searchParams.append('gf_unique', gf_unique);
        this.url = url.href;
    }
    closeSurvey() {
        this.dialog.closeAll();
    }
}
SurveyComponent.ɵfac = function SurveyComponent_Factory(t) { return new (t || SurveyComponent)(i0.ɵɵdirectiveInject(i1$1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i1$1.MatDialog)); };
SurveyComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SurveyComponent, selectors: [["survey"]], decls: 6, vars: 3, consts: [[1, "survey-body"], ["mat-icon-button", "", 1, "close", 3, "click"], ["title", "Feedback Survey", 3, "src"]], template: function SurveyComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "button", 1);
        i0.ɵɵlistener("click", function SurveyComponent_Template_button_click_1_listener() { return ctx.closeSurvey(); });
        i0.ɵɵelementStart(2, "mat-icon");
        i0.ɵɵtext(3, "close");
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(4, "iframe", 2);
        i0.ɵɵpipe(5, "safe");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("src", i0.ɵɵpipeBind1(5, 1, ctx.url), i0.ɵɵsanitizeResourceUrl);
    } }, dependencies: [i2.MatButton, i3.MatIcon, SafePipe], styles: [".close.mat-icon-button[_ngcontent-%COMP%]{float:right;top:5px;right:0;margin-right:5px;margin-top:5px;color:#fff;position:absolute;background-color:#bdbdbd!important}.survey-body[_ngcontent-%COMP%]{width:100%;height:100%;overflow:hidden;position:relative}.survey-body[_ngcontent-%COMP%]   iframe[_ngcontent-%COMP%]{width:100%;height:100%}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SurveyComponent, [{
        type: Component,
        args: [{ selector: 'survey', template: "<div class=\"survey-body\">\r\n  <button (click)=\"closeSurvey()\" class=\"close\" mat-icon-button>\r\n    <mat-icon>close</mat-icon>\r\n  </button>\r\n  <iframe\r\n    title=\"Feedback Survey\"\r\n    [src]=\"url | safe\"\r\n  >\r\n  </iframe>\r\n</div>\r\n", styles: [".close.mat-icon-button{float:right;top:5px;right:0;margin-right:5px;margin-top:5px;color:#fff;position:absolute;background-color:#bdbdbd!important}.survey-body{width:100%;height:100%;overflow:hidden;position:relative}.survey-body iframe{width:100%;height:100%}\n"] }]
    }], function () { return [{ type: i1$1.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: i1$1.MatDialog }]; }, null); })();

function GlobalFooterComponent_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 2);
    i0.ɵɵlistener("click", function GlobalFooterComponent_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.openSurvey()); });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "chat_bubble_outline");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 1, ctx_r0.namespace + "GlobalFooter.Feedback"), "\n");
} }
const _c0 = function (a0) { return { currentYear: a0 }; };
const NAMESPACE_TOKEN = new InjectionToken('NamespaceToken');
class GlobalFooterComponent {
    constructor(analytics, sanitizer, dialog, translate, _namespace = '') {
        this.analytics = analytics;
        this.sanitizer = sanitizer;
        this.dialog = dialog;
        this.translate = translate;
        this._namespace = _namespace;
        this.emailLink = '';
        this.emailText = '';
        this.phoneLink = '';
        this.phoneText = '';
        this.footerText = '';
        this.sanitizedFooterText = '';
        this.brand = '';
        this.globalFeedbackData = {
            iFrameUrl: 'https://endesaopina.getfeedback.com/r/6AVMuaAf/q/1',
            widthSurveyBox: '1150px',
            heightSurveyBox: '600px',
            urlParams: {
                Survey_Response_Flex_User_Email: '',
                Survey_Response_Flex_User_Username: '',
                Survey_Response_Community_User_ID: '',
                gf_unique: '',
            }
        };
        this.disableFeedback = false;
        this.currentYear = new Date().getFullYear() + '';
        this.namespace = _namespace;
    }
    ngAfterViewInit() {
        merge(this.translate.onDefaultLangChange, this.translate.onLangChange).subscribe(() => {
            const currentLang = this.translate.currentLang || this.translate.defaultLang;
            this.brand = currentLang.split('.')[1];
            this.translate.get(`${this.namespace}GlobalFooter.EmailLink`).subscribe((emailLink) => {
                this.emailLink = emailLink;
                this.emailText = this.translate.instant(`${this.namespace}GlobalFooter.EmailText`);
                this.phoneLink = this.translate.instant(`${this.namespace}GlobalFooter.PhoneLink`);
                this.phoneText = this.translate.instant(`${this.namespace}GlobalFooter.PhoneText`);
                this.footerText = this.translate.instant(`${this.namespace}GlobalFooter.Contact`, {
                    email: `<a href=&quot;mailto:${this.emailLink}'&quot; (click)=&quot;emailClick()&quot; target=&quot;_blank&quot;>${this.emailText}</a>`,
                    phone: `<a href=&quot;tel:${this.phoneLink}&quot; (click)=&quot;phoneClick()&quot;>${this.phoneText}</a>`,
                });
                this.sanitizedFooterText = this.sanitizer.bypassSecurityTrustHtml(this.footerText);
            });
        });
    }
    openSurvey() {
        this.dialog.open(SurveyComponent, {
            disableClose: false,
            width: this.globalFeedbackData.widthSurveyBox,
            height: this.globalFeedbackData.heightSurveyBox,
            data: {
                iFrameUrl: this.globalFeedbackData.iFrameUrl,
                urlParams: {
                    Survey_Response_Flex_User_Email: this.globalFeedbackData.urlParams.Survey_Response_Flex_User_Email,
                    Survey_Response_Flex_User_Username: this.globalFeedbackData.urlParams.Survey_Response_Flex_User_Username,
                    Survey_Response_Community_User_ID: this.globalFeedbackData.urlParams.Survey_Response_Community_User_ID,
                    gf_unique: this.globalFeedbackData.urlParams.gf_unique,
                },
            },
        });
    }
    emailClick() {
        this.analytics.pushEvent('Contact_Email', {});
    }
    phoneClick() {
        this.analytics.pushEvent('Contact_Phone', {});
    }
}
GlobalFooterComponent.ɵfac = function GlobalFooterComponent_Factory(t) { return new (t || GlobalFooterComponent)(i0.ɵɵdirectiveInject(i1$2.AnalyticsService), i0.ɵɵdirectiveInject(i1.DomSanitizer), i0.ɵɵdirectiveInject(i1$1.MatDialog), i0.ɵɵdirectiveInject(i4.TranslateService), i0.ɵɵdirectiveInject(NAMESPACE_TOKEN)); };
GlobalFooterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GlobalFooterComponent, selectors: [["global-footer"]], inputs: { disableFeedback: "disableFeedback" }, decls: 5, vars: 8, consts: [["class", "feedback-button", "data-automation", "footer-feedback", "mat-stroked-button", "", "color", "primary", 3, "click", 4, "ngIf"], [3, "innerHTML"], ["data-automation", "footer-feedback", "mat-stroked-button", "", "color", "primary", 1, "feedback-button", 3, "click"]], template: function GlobalFooterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, GlobalFooterComponent_button_0_Template, 5, 3, "button", 0);
        i0.ɵɵelementStart(1, "div");
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(4, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.brand == "ENELX" && !ctx.disableFeedback);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 3, ctx.namespace + "GlobalFooter.Copyright", i0.ɵɵpureFunction1(6, _c0, ctx.currentYear)));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("innerHTML", ctx.sanitizedFooterText, i0.ɵɵsanitizeHtml);
    } }, dependencies: [i5.NgIf, i2.MatButton, i3.MatIcon, i4.TranslatePipe], styles: ["[_nghost-%COMP%]{color:#777;color:var(--primary-text-color, #777777);text-align:center}.feedback-button[_ngcontent-%COMP%]{margin-bottom:30px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GlobalFooterComponent, [{
        type: Component,
        args: [{ selector: 'global-footer', template: "<button class=\"feedback-button\" data-automation=\"footer-feedback\" mat-stroked-button color=\"primary\" (click)=\"openSurvey()\" *ngIf=\"this.brand == 'ENELX' && !this.disableFeedback\">\r\n  <mat-icon>chat_bubble_outline</mat-icon>\r\n  {{ namespace + 'GlobalFooter.Feedback' | translate }}\r\n</button>\r\n<div>{{ namespace + 'GlobalFooter.Copyright' | translate: { currentYear: currentYear } }}</div>\r\n<div [innerHTML]=\"sanitizedFooterText\"></div>\r\n", styles: [":host{color:#777;color:var(--primary-text-color, #777777);text-align:center}.feedback-button{margin-bottom:30px}\n"] }]
    }], function () { return [{ type: i1$2.AnalyticsService }, { type: i1.DomSanitizer }, { type: i1$1.MatDialog }, { type: i4.TranslateService }, { type: undefined, decorators: [{
                type: Inject,
                args: [NAMESPACE_TOKEN]
            }] }]; }, { disableFeedback: [{
            type: Input
        }] }); })();

class GlobalFooterModule {
    static forRoot(config) {
        return {
            ngModule: GlobalFooterModule,
            providers: [{ provide: NAMESPACE_TOKEN, useValue: config.namespace }],
        };
    }
}
GlobalFooterModule.ɵfac = function GlobalFooterModule_Factory(t) { return new (t || GlobalFooterModule)(); };
GlobalFooterModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: GlobalFooterModule });
GlobalFooterModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [{ provide: NAMESPACE_TOKEN, useValue: '' }], imports: [CommonModule, TranslateModule, MatButtonModule, MatIconModule, MatDialogModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GlobalFooterModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, TranslateModule, MatButtonModule, MatIconModule, MatDialogModule],
                declarations: [GlobalFooterComponent, SurveyComponent, SafePipe],
                exports: [GlobalFooterComponent],
                providers: [{ provide: NAMESPACE_TOKEN, useValue: '' }],
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(GlobalFooterModule, { declarations: [GlobalFooterComponent, SurveyComponent, SafePipe], imports: [CommonModule, TranslateModule, MatButtonModule, MatIconModule, MatDialogModule], exports: [GlobalFooterComponent] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { GlobalFooterComponent, GlobalFooterModule };
